import { compact } from "lodash";
import { PortfolioCompany } from "@/stores/PortfolioStore";
import { Portfolio } from "@/common/common";
import { IconName } from "@/components-v2/iconMapping";

export enum CompanySelectorContextType {
  PORTFOLIO = "portfolio",
  COMPANY = "company",
}

export type CompanySelectorContextOption = {
  id: string;
  name: string;
  icon: IconName;
  type: CompanySelectorContextType;
};

export function prepCompanySelectorContextOptions(
  portfolios: Portfolio[],
  companyContext?: PortfolioCompany,
): CompanySelectorContextOption[] {
  return compact([
    companyContext !== undefined && {
      id: companyContext.organisationNumber,
      icon: "buildings",
      name: companyContext.name,
      type: CompanySelectorContextType.COMPANY,
    },
    ...portfolios.map<CompanySelectorContextOption>((portfolio) => ({
      id: portfolio.id,
      icon: "suitcaseSimple",
      name: portfolio.name,
      type: CompanySelectorContextType.PORTFOLIO,
    })),
  ]);
}
